import React, { useEffect, useState, Fragment } from "react";
import { useDispatch, useSelector } from "react-redux";
import Typography from "@mui/material/Typography";
import { useTranslation } from "react-i18next";

import TableRequest from "./table";
import dayjs from "dayjs";
import ButtonBlue from "../../../shared/general/ButtonBlue";
import { Button, styled } from "@mui/material";
import DoneAllIcon from "@mui/icons-material/DoneAll";
import CloseIcon from "@mui/icons-material/Close";
import DialogConfirmReject from "../dialogConfirmReject";
import { approveRequestLeaveByAdmin, getCompanyPendingRequestLeave } from "../../../../../actions/leave";
import { openNotificationAlert } from "../../../../../actions/notificationAlert";

const StyledNotApprove = styled(Button)({
  color: "#ffffff",
  backgroundColor: "#d32f2f",
  borderColor: "#d32f2f",
  borderRadius: 8,
  "&:hover": {
    backgroundColor: "#c62828",
    borderColor: "#c62828",
  },
});

const Leave = (props) => {
  const { idCompany, searchName, searchDate, setNumberOfList } = props;
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { result: userProfile } = useSelector((state) => state.userProfile);

  const { result: companyPendingRequestLeave } = useSelector(state => state.companyPendingRequestLeave);
  
  const [dataTableWaiting, setDataTableWaiting] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [approvalSelected, setApprovalSelected] = useState([]);
  const [openDialogReject, setOpenDialogReject] = useState(false);

  const handleApprovalRequest = async (approve) => {

    const idLeaveLV1 = approvalSelected.filter(item => {
      return (!item.idLeaveEmployeesWithdraw && item.isManagerLV1Approve === null && (item.isDoubleApproval === 1 || (item.isDoubleApproval === 0 && item.approvalLevel === 1)))
    }).map(item => item.idLeave);

    const idLeaveLV2 = approvalSelected.filter(item => {
      return (!item.idLeaveEmployeesWithdraw && item.isManagerLV2Approve === null && (item.isDoubleApproval === 1 || (item.isDoubleApproval === 0 && item.approvalLevel === 2)))
    }).map(item => item.idLeave)

    const leaveEmployeeWithdraw = approvalSelected.filter(item => {
      return (item.idLeaveEmployeesWithdraw && item.isApprove === null);
    })

    const idLeaveEmployeesWithdraw = leaveEmployeeWithdraw.map(item => item.idLeaveEmployeesWithdraw);
    const idLeaveWithdraw = leaveEmployeeWithdraw.map(item => item.idLeave);

    const formData = [
      {
        idLeaveLV1: idLeaveLV1,
        isManagerLV1Approve: approve,
        managerLV1ApproveDate: dayjs().format("YYYY-MM-DD HH:mm:ss"),
        managerLV1Comment: null,
      },
      {
        idLeaveLV2: idLeaveLV2,
        isManagerLV2Approve: approve,
        managerLV2ApproveDate: dayjs().format("YYYY-MM-DD HH:mm:ss"),
        managerLV2Comment: null,
      },
      {
        idLeaveEmployeesWithdraw: idLeaveEmployeesWithdraw,
        idLeave: idLeaveWithdraw,
        isApprove: approve,
        approveDate: dayjs().format("YYYY-MM-DD HH:mm:ss"),
        commentManager: null,
      },
    ];

    const result = await dispatch(approveRequestLeaveByAdmin(formData));

    if (result && result.status === 200) {
      dispatch(openNotificationAlert({
        type: "success",
        message: t("DataSaveSuccessful"),
      }));
      setApprovalSelected([]);
      dispatch(getCompanyPendingRequestLeave(idCompany, {
        start: searchDate.start? dayjs(searchDate.start).format("YYYY-MM-DD"): null,
        end: searchDate.end? dayjs(searchDate.end).format("YYYY-MM-DD"): null,
      }));
    } else {
      dispatch(openNotificationAlert({
        type: "error",
        message: t("AnErrorOccurred")
      }));
    }
    setOpenDialogReject(false);
  };

  useEffect(() => {
    setIsLoading(true);
    if (companyPendingRequestLeave) {
      setDataTableWaiting(
        companyPendingRequestLeave.filter((x) => {
          if(
            (
              (searchName && searchName.length > 0) ? 
              (
                x.firstname.toUpperCase().indexOf(searchName.toUpperCase()) >= 0 ||
                x.lastname.toUpperCase().indexOf(searchName.toUpperCase()) >= 0
              )
              : true
            )
          ){
            return true;
          } else {
            return false;
          }
        })
      );
    }
    setIsLoading(false);
  }, [companyPendingRequestLeave, searchName]);

  return (
    <Fragment>
      {isLoading ? 
        <div style={{ width:"100%", display:"flex", justifyContent:"center", paddingTop: 16 }}>
          <Typography style={{ fontSize: 20, fontWeight: 500 }}>{t("LoadingData")}</Typography>
        </div>
        :
        <Fragment>
          <div style={{ display:"flex", justifyContent:"space-between", alignItems: "center", marginBottom: 16 }}>
            <div style={{ minHeight: 40 }}>
              {approvalSelected.length > 0 &&
                <>
                  <ButtonBlue
                    style={{ marginRight: 8 }}
                    startIcon={<DoneAllIcon />}
                    variant="contained"
                    onClick={() => handleApprovalRequest(1)}
                  >
                    {`${t("Approve")} ${
                      approvalSelected.length > 0
                        ? `${approvalSelected.length} ${t("Items")}`
                        : ""
                    }`}
                  </ButtonBlue>
                  <StyledNotApprove
                    startIcon={<CloseIcon />}
                    variant="outlined"
                    onClick={() => setOpenDialogReject(true)}
                  >
                    {`${t("Disapproval")} ${
                      approvalSelected.length > 0
                        ? `${approvalSelected.length} ${t("Items")}`
                        : ""
                    }`}
                  </StyledNotApprove>
                </>
              }
            </div>
            <Typography style={{ fontSize: 20, fontWeight: 500, color: "#e46a76" }}>
              {`${(dataTableWaiting && dataTableWaiting.length) || 0} ${t("Items")}`}
            </Typography>
          </div>

          {companyPendingRequestLeave && dataTableWaiting && (
            <TableRequest 
              data={dataTableWaiting} 
              searchName={searchName} 
              approvalSelected={approvalSelected}
              setApprovalSelected={setApprovalSelected}
              setNumberOfList={setNumberOfList}
            />
          )}
          {openDialogReject && (
            <DialogConfirmReject
              open={openDialogReject}
              onClose={() => setOpenDialogReject(false)}
              handleSubmit={() => handleApprovalRequest(0)}
            />
          )}
        </Fragment>
      }
    </Fragment>
  );
};

export default Leave;
